// src/components/Sidebar.js
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../AuthContext';

function Sidebar() {
  // Uncomment and use logout if needed:
  // const { logout } = useContext(AuthContext);

  return (
    <div className="hidden bg-gray-50 md:flex md:w-64 md:flex-col">
      <div className="flex flex-col overflow-y-auto">
        {/* Logo container removed to eliminate extra space */}

        <div className="flex flex-col justify-between flex-1 h-full pt-4">
          <div className="space-y-2">
            <nav className="flex-1 space-y-2">
              {/* Email Link */}
              <Link
                to="/campaigns"
                title="Campaigns"
                className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 w-5 h-5 mr-4 text-red-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
               Campaigns
              </Link>

              {/* Linkedin Link */}
              <Link
                to="/multilinkedin"
                title="Linkedin"
                className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 w-5 h-5 mr-4 text-blue-700"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.762 2.239 5 5 5h14c2.762 0 5-2.238 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-9h3v9zm-1.5-10.29a1.73 1.73 0 110-3.46 1.73 1.73 0 010 3.46zm13.5 10.29h-3v-4.5c0-1.076-.023-2.461-1.5-2.461-1.5 0-1.73 1.172-1.73 2.382v4.579h-3v-9h2.882v1.229h.041c.402-.762 1.386-1.562 2.852-1.562 3.047 0 3.611 2.005 3.611 4.612v4.721z" />
                </svg>
                Linkedin Reach
              </Link>

                     {/* A/B Testing */}
                     <Link
                to="/ABdrafts"
                title="A/B Testing"
                className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
              >
                {/* Custom overlapping squares icon */}
                <svg 
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 w-5 h-5 mr-4 text-pink-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <rect x="2" y="2" width="8" height="8" rx="1" />
                  <rect x="10" y="10" width="8" height="8" rx="1" fillOpacity="0.5" />
                </svg>
                A/B Testing
              </Link>

              {/* All Drafts */}
              <Link
                to="/drafts"
                title="All Drafts"
                className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 w-5 h-5 mr-4 text-gray-600"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M2 4a2 2 0 012-2h4l2 2h6a2 2 0 012 2v2H2V4z" />
                  <path d="M2 8h16v6a2 2 0 01-2 2H4a2 2 0 01-2-2V8z" />
                </svg>
                All Drafts
              </Link>

              {/* New Draft */}
              <Link
                to="/generateDraft"
                title="New Draft"
                className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 w-5 h-5 mr-4 text-green-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                  <path
                    fillRule="evenodd"
                    d="M4 13V7a1 1 0 011-1h2a1 1 0 011 1v6H4z"
                    clipRule="evenodd"
                  />
                </svg>
                New Draft
              </Link>

              {/* Draft Templates */}
              <Link
                to="/displayDrafts"
                title="Draft Templates"
                className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="flex-shrink-0 w-5 h-5 mr-4 text-purple-500"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8.414a2 2 0 00-.586-1.414l-4.414-4.414A2 2 0 0011.586 2H4z" />
                </svg>
                Draft Templates
              </Link>

       
            </nav>
          </div>

          <hr className="border-gray-200" />

          <nav className="space-y-2 mt-4">
            {/* Settings */}
            <Link
              to="/settings"
              title="Settings"
              className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0 w-5 h-5 mr-4 text-indigo-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M11.3 1.046a1 1 0 00-2.6 0l-.32 1.045a8.034 8.034 0 00-2.019.99L5.05 2.402a1 1 0 00-1.414 0L2.09 4.948a1 1 0 00-.292 1.118l.76 2.185a8.01 8.01 0 000 2.01l-.76 2.184a1 1 0 00.292 1.118l1.545 1.545a1 1 0 001.414 0l1.82-1.82a8.03 8.03 0 002.02.99l.32 1.045a1 1 0 001.99 0l.32-1.045a8.034 8.034 0 002.02-.99l1.82 1.82a1 1 0 001.414 0l1.545-1.545a1 1 0 00.292-1.118l-.76-2.184a8.01 8.01 0 000-2.01l.76-2.185a1 1 0 00-.292-1.118L16.95 2.402a1 1 0 00-1.414 0l-1.82 1.82a8.03 8.03 0 00-2.02-.99l-.32-1.045zM10 13a3 3 0 110-6 3 3 0 010 6z"
                  clipRule="evenodd"
                />
              </svg>
              Settings
            </Link>

            {/* Additional Links Below Settings */}
            

            

            

            <Link
              to="/allInvoices"
              title="Invoices"
              className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
            >
              {/* Document Icon for Invoices */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0 w-5 h-5 mr-4 text-blue-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5l2 2h5a2 2 0 012 2v12a2 2 0 01-2 2z" 
                />
              </svg>
              Invoices
            </Link>

            <Link
              to="/creditPlans"
              title="Credits"
              className="no-underline flex items-center px-4 py-3 text-sm font-medium text-gray-900 transition-all duration-200 hover:bg-gray-200 group"
            >
              {/* Credit Card Icon for Wallet */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="flex-shrink-0 w-5 h-5 mr-4 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-2m-2-4h.01" 
                />
              </svg>
              My Credits
            </Link>

            

            {/* Help */}
           
          </nav>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
